import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, ShoppingBag } from 'lucide-react';
const NAMES = ['Mariana de Salta', 'Valentina de Córdoba', 'Camila de Buenos Aires', 'Sofía de Rosario', 'Isabella de Mendoza', 'Martina de Santa Fe', 'Lucía de Neuquén', 'Fernanda de La Plata', 'Gabriela de Mar del Plata'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [info, setInfo] = useState({
    name: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomTime = Math.floor(Math.random() * 10) + 1; // 1-10 minutes ago
      setInfo({
        name: randomName,
        time: `${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, Math.random() * 15000 + 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-44">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full" data-id="element-45">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-4 border border-purple-100 flex items-center gap-3" data-id="element-46">
            <div className="bg-gradient-to-br from-pink-400 to-purple-500 p-2 rounded-full flex-shrink-0 text-white shadow-md" data-id="element-47">
              <ShoppingBag className="w-5 h-5" data-id="element-48" />
            </div>
            <div data-id="element-49">
              <p className="text-xs font-bold text-gray-800" data-id="element-50">{info.name}</p>
              <div className="flex items-center gap-1" data-id="element-51">
                <CheckCircle className="w-3 h-3 text-green-500" data-id="element-52" />
                <p className="text-[10px] text-gray-500 font-medium" data-id="element-53">
                  Compró Mega Pack Globología Mágica — hace {info.time}
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}